var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-capitalize-first-word"},[_vm._v(_vm._s(_vm.title))]),(_vm.route)?_c('div',{staticClass:"list-buttons mb-3 pb-3"},[_c('b-button',{directives:[{name:"t",rawName:"v-t",value:(_vm.localeSection + '.new'),expression:"localeSection + '.new'"}],attrs:{"to":{
        name: _vm.route,
        params: { id: '00000000-0000-0000-0000-000000000000' }
      },"variant":"outline-primary"}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }